/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  GeocodeSuggestion,
  GetGeocodeDetailsParams,
  GetGeocodeReverseParams,
  GetGeocodeSearchParams,
  PlaceDetails,
  ReverseGeocode,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetGeocodeSearchUrl = (params?: GetGeocodeSearchParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/geocode/search?${stringifiedParams}`
    : `/api/v1/geocode/search`
}

/**
 * @summary Address suggestions for what has been typed so far
 */
export const getGeocodeSearch = async (
  params?: GetGeocodeSearchParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GeocodeSuggestion[]> => {
  return customFetch<GeocodeSuggestion[]>(getGetGeocodeSearchUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetGeocodeSearchQueryKey = (params?: GetGeocodeSearchParams) => {
  return [`/api/v1/geocode/search`, ...(params ? [params] : [])] as const
}

export const getGetGeocodeSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeocodeSearch>>,
  TError = unknown,
>(
  params?: GetGeocodeSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeSearch>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetGeocodeSearchQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeocodeSearch>>> = ({ signal }) =>
    getGeocodeSearch(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeocodeSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeocodeSearchQueryResult = NonNullable<Awaited<ReturnType<typeof getGeocodeSearch>>>
export type GetGeocodeSearchQueryError = unknown

export function useGetGeocodeSearch<
  TData = Awaited<ReturnType<typeof getGeocodeSearch>>,
  TError = unknown,
>(
  params: undefined | GetGeocodeSearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeSearch>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeocodeSearch>>,
          TError,
          Awaited<ReturnType<typeof getGeocodeSearch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeocodeSearch<
  TData = Awaited<ReturnType<typeof getGeocodeSearch>>,
  TError = unknown,
>(
  params?: GetGeocodeSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeSearch>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeocodeSearch>>,
          TError,
          Awaited<ReturnType<typeof getGeocodeSearch>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeocodeSearch<
  TData = Awaited<ReturnType<typeof getGeocodeSearch>>,
  TError = unknown,
>(
  params?: GetGeocodeSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeSearch>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Address suggestions for what has been typed so far
 */

export function useGetGeocodeSearch<
  TData = Awaited<ReturnType<typeof getGeocodeSearch>>,
  TError = unknown,
>(
  params?: GetGeocodeSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeSearch>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGeocodeSearchQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetGeocodeReverseUrl = (params?: GetGeocodeReverseParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/geocode/reverse?${stringifiedParams}`
    : `/api/v1/geocode/reverse`
}

/**
 * @summary The address at a point on the map
 */
export const getGeocodeReverse = async (
  params?: GetGeocodeReverseParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<ReverseGeocode> => {
  return customFetch<ReverseGeocode>(getGetGeocodeReverseUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetGeocodeReverseQueryKey = (params?: GetGeocodeReverseParams) => {
  return [`/api/v1/geocode/reverse`, ...(params ? [params] : [])] as const
}

export const getGetGeocodeReverseQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeocodeReverse>>,
  TError = unknown,
>(
  params?: GetGeocodeReverseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeReverse>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetGeocodeReverseQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeocodeReverse>>> = ({ signal }) =>
    getGeocodeReverse(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeocodeReverse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeocodeReverseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeocodeReverse>>
>
export type GetGeocodeReverseQueryError = unknown

export function useGetGeocodeReverse<
  TData = Awaited<ReturnType<typeof getGeocodeReverse>>,
  TError = unknown,
>(
  params: undefined | GetGeocodeReverseParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeReverse>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeocodeReverse>>,
          TError,
          Awaited<ReturnType<typeof getGeocodeReverse>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeocodeReverse<
  TData = Awaited<ReturnType<typeof getGeocodeReverse>>,
  TError = unknown,
>(
  params?: GetGeocodeReverseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeReverse>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeocodeReverse>>,
          TError,
          Awaited<ReturnType<typeof getGeocodeReverse>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeocodeReverse<
  TData = Awaited<ReturnType<typeof getGeocodeReverse>>,
  TError = unknown,
>(
  params?: GetGeocodeReverseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeReverse>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The address at a point on the map
 */

export function useGetGeocodeReverse<
  TData = Awaited<ReturnType<typeof getGeocodeReverse>>,
  TError = unknown,
>(
  params?: GetGeocodeReverseParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeReverse>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGeocodeReverseQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetGeocodeDetailsUrl = (params?: GetGeocodeDetailsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/geocode/details?${stringifiedParams}`
    : `/api/v1/geocode/details`
}

/**
 * @summary Where a suggestion actually is
 */
export const getGeocodeDetails = async (
  params?: GetGeocodeDetailsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PlaceDetails> => {
  return customFetch<PlaceDetails>(getGetGeocodeDetailsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetGeocodeDetailsQueryKey = (params?: GetGeocodeDetailsParams) => {
  return [`/api/v1/geocode/details`, ...(params ? [params] : [])] as const
}

export const getGetGeocodeDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeocodeDetails>>,
  TError = unknown,
>(
  params?: GetGeocodeDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeDetails>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetGeocodeDetailsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getGeocodeDetails>>> = ({ signal }) =>
    getGeocodeDetails(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getGeocodeDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGeocodeDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeocodeDetails>>
>
export type GetGeocodeDetailsQueryError = unknown

export function useGetGeocodeDetails<
  TData = Awaited<ReturnType<typeof getGeocodeDetails>>,
  TError = unknown,
>(
  params: undefined | GetGeocodeDetailsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeocodeDetails>>,
          TError,
          Awaited<ReturnType<typeof getGeocodeDetails>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeocodeDetails<
  TData = Awaited<ReturnType<typeof getGeocodeDetails>>,
  TError = unknown,
>(
  params?: GetGeocodeDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGeocodeDetails>>,
          TError,
          Awaited<ReturnType<typeof getGeocodeDetails>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGeocodeDetails<
  TData = Awaited<ReturnType<typeof getGeocodeDetails>>,
  TError = unknown,
>(
  params?: GetGeocodeDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeDetails>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Where a suggestion actually is
 */

export function useGetGeocodeDetails<
  TData = Awaited<ReturnType<typeof getGeocodeDetails>>,
  TError = unknown,
>(
  params?: GetGeocodeDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getGeocodeDetails>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetGeocodeDetailsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
